import { render, staticRenderFns } from "./swagger-ui-wrapper.vue?vue&type=template&id=24f3120e&"
import script from "./swagger-ui-wrapper.vue?vue&type=script&lang=js&"
export * from "./swagger-ui-wrapper.vue?vue&type=script&lang=js&"
import style0 from "./swagger-ui-wrapper.vue?vue&type=style&index=0&id=24f3120e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports